export default {
  goBackProfile: 'Профиль',
  download: 'Скачать договор',
  changes: 'Изменения от {lastModified}',
  sign: 'Подписать',
  send: 'Отправить',
  correct: 'Корректировать',
  cancel: 'Отменить',
  yourComment: 'Ваш комментарий',
  contactManager: 'Связаться с менеджером',
  commentSent: 'Комментарий успешно отправлен 👍'
}
